
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-1'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>메인화면 관리 - 롤링 배너 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminRollingBannerManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button>
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 리스트 정렬은 ID와 상관없이 순서대로이며, 상단이 우선 순위가 높습니다.</p>
            <p>2. 왼쪽 3선 작대기를 클릭&드래그하여 위/아래로 이동할 수 있습니다.</p>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_rolling_banner,
  update_rolling_banner_order,
  delete_rolling_banner
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminRollingBannerManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminRollingBannerManagementAdd?rolling_banner_ID=${this.tabulator.getSelectedData()[0].rolling_banner_ID}`
      }
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.rolling_banner_ID)
      })
      delete_rolling_banner(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    }
  },
  mounted () {
    get_rolling_banner().then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        columns: [
          {rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30},
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: 'ID', field: 'rolling_banner_ID', headerSort: false},
          {title: '롤링배너명', field: 'rolling_banner_name', headerSort: false},
          {title: '사용 여부', field: 'rolling_banner_status', headerSort: false},
          {title: '등록 일자', field: 'rolling_banner_registe', headerSort: false},
          {title: '수정 일자', field: 'rolling_banner_modified', headerSort: false}
        ]
      })
      this.tabulator.on('rowMoved', function (row) {
        let temp_rolling_banner_order_array = []
        let rolling_banner_order = 0
        const table = row.getTable()
        table.getRows().forEach(element => {
          temp_rolling_banner_order_array.push({
            rolling_banner_order: rolling_banner_order,
            rolling_banner_ID: element._row.data.rolling_banner_ID
          })
          rolling_banner_order++
        })
        update_rolling_banner_order(temp_rolling_banner_order_array).then(result => {
          if (result === undefined) {
            alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.')
          }
        })
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/MainManagement/AdminRollingBannerManagement.vue